export default __webpack_public_path__ + "static/media/install-app-2.731467c2.jpg";